import React, { useState } from "react";
import Modal from "react-modal"; // You need to install react-modal package

const OtpModal = ({ isOpen, onClose, onVerify, onCancel }) => {
  const [otp, setOtp] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    onVerify(otp);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="fixed inset-0 flex items-center justify-center z-50 p-4 sm:p-6"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 z-40" // Overlay background with lower z-index than modal content
    >
      <div className="bg-white p-6 sm:p-10 rounded-lg shadow-lg w-full max-w-md max-h-[90vh] overflow-auto z-50">
        <h2 className="text-xl sm:text-2xl font-semibold text-center mb-2">
          Enter OTP
        </h2>
        <p className="p-2 mb-2 text-center text-sm sm:text-base">
          The OTP has been sent to your email.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="text"
            placeholder="Enter your OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
            className="p-3 bg-gray-100 rounded-lg"
          />
          <button
            type="submit"
            className="w-full p-3 bg-black font-bold text-white rounded transition duration-300 ease-in-out"
          >
            Verify OTP
          </button>
        </form>
        <button
          onClick={onCancel}
          className="mt-4 text-red-500 underline w-full text-center"
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default OtpModal;
